import { render, staticRenderFns } from "./PiHoleTopQueries.vue?vue&type=template&id=186df627&scoped=true"
import script from "./PiHoleTopQueries.vue?vue&type=script&lang=js"
export * from "./PiHoleTopQueries.vue?vue&type=script&lang=js"
import style0 from "./PiHoleTopQueries.vue?vue&type=style&index=0&id=186df627&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186df627",
  null
  
)

export default component.exports